import React from 'react';

import { Counter } from 'src/components/B2C/Input';
import { SelectButton } from './ExtraCardInput.style';

export interface ExtraCardInputProps {
  minQuantity?: number;
  maxQuantity?: number;
  requiresQuantity?: boolean;
  prepaid?: boolean;
  included?: boolean;
  input: {
    name: string;
    value: number;
    onChange: (value: number) => void;
    disabled?: boolean;
  };
}

const ExtraCardInputMultiple = ({
  input,
  maxQuantity,
  minQuantity = 0,
}: ExtraCardInputProps) => {
  return (
    <Counter
      input={{
        ...input,
        max: maxQuantity,
        min: minQuantity,
      }}
    />
  );
};

const ExtraCardInputOne = ({
  included,
  prepaid,
  minQuantity,
  input,
}: ExtraCardInputProps) => {
  const inputText = included
    ? 'Included'
    : prepaid
    ? 'Prepaid'
    : input.value === 1
    ? 'Remove'
    : 'Select';

  const isDisabled = input.disabled || minQuantity == 1 || prepaid || included;

  return (
    <SelectButton
      onClick={() => !isDisabled && input?.onChange(input?.value === 0 ? 1 : 0)}
      disabled={isDisabled}
    >
      {inputText}
    </SelectButton>
  );
};

const ExtraCardInput = ({ requiresQuantity, ...props }: ExtraCardInputProps) =>
  !requiresQuantity ? (
    <ExtraCardInputOne {...props} />
  ) : (
    <ExtraCardInputMultiple {...props} />
  );

export default ExtraCardInput;
